import type { LucideIcon } from "lucide-react";
import { MENU, isMenuGroup } from "@/config/menu";
import { iconForLabel } from "./menuIcons";

// Adapta a árvore agnóstica de framework (config/menu.ts) para o shape que
// AppSidebar e LegacyTopBar já usavam — mesma fonte, duas skins.
export interface ResolvedSubItem {
  label: string;
  href: string;
}

export interface ResolvedMenuItem {
  label: string;
  icon: LucideIcon;
  href?: string;
  subItems?: ResolvedSubItem[];
}

export const resolvedMenu: ResolvedMenuItem[] = MENU.map((entry) =>
  isMenuGroup(entry)
    ? {
        label: entry.label,
        icon: iconForLabel(entry.label),
        subItems: entry.children.map((child) => ({ label: child.label, href: child.path })),
      }
    : {
        label: entry.label,
        icon: iconForLabel(entry.label),
        href: entry.path,
      },
);
